/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface InvoiceSummaryResponse
 */
export interface InvoiceSummaryResponse {
    /**
     * 
     * @type {Date}
     * @memberof InvoiceSummaryResponse
     */
    invoiceDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof InvoiceSummaryResponse
     */
    billingDate: Date;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof InvoiceSummaryResponse
     */
    numberOfInvoices: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof InvoiceSummaryResponse
     */
    numberWithValidVaults: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof InvoiceSummaryResponse
     */
    numberWithoutValidVaults: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof InvoiceSummaryResponse
     */
    numberEmailed: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof InvoiceSummaryResponse
     */
    numberReadyForInvoice: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof InvoiceSummaryResponse
     */
    numberReadyForReceipt: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof InvoiceSummaryResponse
     */
    numberInvoiced: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof InvoiceSummaryResponse
     */
    numberFailed: ApiUserTasksGetPageParameter;
}

/**
 * Check if a given object implements the InvoiceSummaryResponse interface.
 */
export function instanceOfInvoiceSummaryResponse(value: object): value is InvoiceSummaryResponse {
    if (!('invoiceDate' in value) || value['invoiceDate'] === undefined) return false;
    if (!('billingDate' in value) || value['billingDate'] === undefined) return false;
    if (!('numberOfInvoices' in value) || value['numberOfInvoices'] === undefined) return false;
    if (!('numberWithValidVaults' in value) || value['numberWithValidVaults'] === undefined) return false;
    if (!('numberWithoutValidVaults' in value) || value['numberWithoutValidVaults'] === undefined) return false;
    if (!('numberEmailed' in value) || value['numberEmailed'] === undefined) return false;
    if (!('numberReadyForInvoice' in value) || value['numberReadyForInvoice'] === undefined) return false;
    if (!('numberReadyForReceipt' in value) || value['numberReadyForReceipt'] === undefined) return false;
    if (!('numberInvoiced' in value) || value['numberInvoiced'] === undefined) return false;
    if (!('numberFailed' in value) || value['numberFailed'] === undefined) return false;
    return true;
}

export function InvoiceSummaryResponseFromJSON(json: any): InvoiceSummaryResponse {
    return InvoiceSummaryResponseFromJSONTyped(json, false);
}

export function InvoiceSummaryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceSummaryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'invoiceDate': (new Date(json['invoiceDate'])),
        'billingDate': (new Date(json['billingDate'])),
        'numberOfInvoices': ApiUserTasksGetPageParameterFromJSON(json['numberOfInvoices']),
        'numberWithValidVaults': ApiUserTasksGetPageParameterFromJSON(json['numberWithValidVaults']),
        'numberWithoutValidVaults': ApiUserTasksGetPageParameterFromJSON(json['numberWithoutValidVaults']),
        'numberEmailed': ApiUserTasksGetPageParameterFromJSON(json['numberEmailed']),
        'numberReadyForInvoice': ApiUserTasksGetPageParameterFromJSON(json['numberReadyForInvoice']),
        'numberReadyForReceipt': ApiUserTasksGetPageParameterFromJSON(json['numberReadyForReceipt']),
        'numberInvoiced': ApiUserTasksGetPageParameterFromJSON(json['numberInvoiced']),
        'numberFailed': ApiUserTasksGetPageParameterFromJSON(json['numberFailed']),
    };
}

export function InvoiceSummaryResponseToJSON(json: any): InvoiceSummaryResponse {
    return InvoiceSummaryResponseToJSONTyped(json, false);
}

export function InvoiceSummaryResponseToJSONTyped(value?: InvoiceSummaryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invoiceDate': value['invoiceDate'].toISOString().substring(0,10),
        'billingDate': value['billingDate'].toISOString().substring(0,10),
        'numberOfInvoices': ApiUserTasksGetPageParameterToJSON(value['numberOfInvoices']),
        'numberWithValidVaults': ApiUserTasksGetPageParameterToJSON(value['numberWithValidVaults']),
        'numberWithoutValidVaults': ApiUserTasksGetPageParameterToJSON(value['numberWithoutValidVaults']),
        'numberEmailed': ApiUserTasksGetPageParameterToJSON(value['numberEmailed']),
        'numberReadyForInvoice': ApiUserTasksGetPageParameterToJSON(value['numberReadyForInvoice']),
        'numberReadyForReceipt': ApiUserTasksGetPageParameterToJSON(value['numberReadyForReceipt']),
        'numberInvoiced': ApiUserTasksGetPageParameterToJSON(value['numberInvoiced']),
        'numberFailed': ApiUserTasksGetPageParameterToJSON(value['numberFailed']),
    };
}

